import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ApiDataService } from "src/app/api/services/api-data.service";
import { GridDataProvider } from "src/app/controls/grid/services/grid-data-provider.interface";
import { RegisteredCrewsTable } from "../models/registered-crews-table.interface";
import { UpdateAuthorNote } from "../models/update-author-note.interface";
import { ColumnDefinition } from "src/app/controls/grid/models/column-definition.interface";
import { GRID_COLUMN_DEFINITION } from "../constants/grid-column-definition.constant";

@Injectable()
export class RegisteredCrewsTableService implements GridDataProvider {
    
    /** Api data service reference */
    private service = inject(ApiDataService);

    /** @inheritdoc */
    public getTableName(competitionId: number): Observable<string> {
        return this.service.get<string>('competitions-simple/name/' + competitionId);
    }

    /** @inheritdoc */
    public getGridData(competitionId: number): Observable<RegisteredCrewsTable[]> {
        return this.service.getAll<RegisteredCrewsTable>('competition-registrations/competition/' + competitionId);
    }

    /** @inheritdoc */
    public getColumnDefinition(): Observable<ColumnDefinition[]> {
        return of(GRID_COLUMN_DEFINITION);
    }

    /** @inheritdoc */
    public updateAuthorNote(data: UpdateAuthorNote): Observable<boolean> {
        return this.service.patch<boolean>('competition-registrations/update-author-note', data);
    }

    /** @inheritdoc */
    public removeCrewFromCompetition(competitionRegistrationId: number): Observable<boolean> {
        return this.service.delete<boolean>('competition-registrations', competitionRegistrationId);
    }
}